export var mutations = {
    setLoading: function (state, payload) { return state.loading = payload; },
    setCompanies: function (state, payload) { return state.companies = payload; },
};
